/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
App.Form = class Form {
  constructor() {
    this.foundationPresent = typeof(Foundation) !== "undefined";
    this.selectizePresent = typeof(Selectize) !== "undefined";

    this.selectors = {
      abideForm: 'form[data-abide]',
      accordianCheckbox: '[data-behavior~=accordian-checkbox]',
      clearAllCheckboxes: '[data-behavior~=clear-all-checkboxes]',
      hasHeaderSubmit: 'form[data-behavior~=has-header-submit]',
      headerSubmitButton: '#page-header button[type="submit"]',
      noKeyboard: 'form select[data-behavior~=no-keyboard]',
      optionalFields: '[data-type~=optional-fields]',
      optionalFieldsInput: '[data-type~=optional-fields] :input',
      selectableCheckbox: 'form #selectable input[type=checkbox]',
      selectAllCheckboxes: '[data-behavior~=select-all-checkboxes]',
      submitForm: '[data-behavior~=submit-form]',
      toggleOptionalFields: '[data-behavior~=toggle-optional-fields]',
      toggleStateHidden: '[data-toggle-state~=hidden]',
      toggleStateShown: '[data-toggle-state~=shown]'
    };
  }

  // Public API

  render() {
    this.renderAbide();
    this.renderAccordianCheckbox();
    this.renderClearAllCheckboxes();
    this.renderHasHeaderSubmit();
    this.renderSelectableCheckbox();
    this.renderSelectAllCheckboxes();
    this.renderSelectized();
    this.renderSubmitForm();
    this.renderToggleStateShown();
    return this.renderToggleOptionalFields();
  }

  setInputValue(element) {
    const $el = $(element);
    $('input#' + $el.data('input-id')).val($el.data('value'));
    $('input#' + $el.data('kid-id')).val($el.data('kid-value'));
    if ($el.data('submit')) {
      return $el.parents('form').submit();
    }
  }

  // Private API

  fetchAccordianFields($el) {
    return $('#' + ($el.data('fields').id || '').split(',').join(',#'));
  }

  fetchOptionalFields($el) {
    let optionalFields = $el.closest('.field').find(this.selectors.optionalFields);
    // set for Foundation forms
    if (optionalFields.length === 0) {
      optionalFields = $('#' + $el.data('fields').id);
    }
    return optionalFields;
  }

  fetchSelectableCheckboxes(el) {
    return $($(el).data('selectable')).find('input[type=checkbox]');
  }

  foundationPresent() {
    return typeof(Foundation) !== "undefined";
  }

  hasExpectedValue($el) {
    const expectedValues = ($el.data('expected-values') + '').split(',');
    return $.inArray($el.val(), expectedValues) !== -1;
  }

  hasExpectedValues($el) {
    return typeof $el.data('expected-values') !== 'undefined';
  }

  hide($el) {
    return $el.slideUp('slow');
  }

  renderAbide() {
    const self = this;
    const abideForms = $(this.selectors.abideForm);
    abideForms.on('submit', function(e) {
      $(this).foundation('validateForm');
      if (!$(this).data('valid')) {
        // scroll to the first invalid input (minus 115 for sticky header)
        $('html, body').animate(
          { scrollTop: $('.is-invalid-label').first().offset().top-115 },
          'slow'
        );
        return e.preventDefault();
      }
    });

    // validate forms to show errors when server-side validation failed
    abideForms.each(function() {
      if ($(this).find('.form-validation-alert').length) {
        return $(this).foundation('validateForm');
      }
    });

    $(document).on('formvalid.zf.abide', (ev, elem) => $(elem).data('valid', true));

    return $(document).on('forminvalid.zf.abide', function(ev, form) {
      $(form).data('valid', false);
      return Ladda.stopAll();
    });
  }

  renderAccordianCheckbox() {
    const self = this;

    $(this.selectors.accordianCheckbox).on('change', function() {
      const $el = $(this);
      const $fields = self.fetchAccordianFields($el);
      return self.toggle($fields);
    });

    return $(this.selectors.accordianCheckbox).each(function() {
      const $el = $(this);
      const $fields = self.fetchAccordianFields($el);
      if ($el.prop('checked')) {
        return self.toggle($fields);
      }
    });
  }

  renderClearAllCheckboxes() {
    const self = this;
    // 'Clear all'
    return $(this.selectors.clearAllCheckboxes).on('click', function(e) {
      e.preventDefault();
      return self.fetchSelectableCheckboxes(this).prop('checked', false).trigger('change');
    });
  }

  renderHasHeaderSubmit() {
    const self = this;
    // change state on main 'Save' button
    return $(this.selectors.hasHeaderSubmit).on('submit', function() {
      if ($(this).data('valid')) {
        Ladda.create(document.querySelector(self.selectors.headerSubmitButton)).start();
        const formButton = this.querySelector('button[type=submit], input[type=submit]');
        if (formButton !== null) {
          return Ladda.create(formButton).start();
        }
      } else {
        return Ladda.stopAll();
      }
    });
  }

  renderSelectableCheckbox() {
    // add .not-selected class to collection checkboxes
    const self = this;

    $(this.selectors.selectableCheckbox).each(function() {
      return self.toggleLabelsClassForCheckboxes($(this));
    });

    return $(this.selectors.selectableCheckbox).on('change', function() {
      return self.toggleLabelsClassForCheckboxes($(this));
    });
  }

  renderSelectAllCheckboxes() {
    const self = this;
    // 'Select all'
    return $(this.selectors.selectAllCheckboxes).on('click', function(e) {
      e.preventDefault();
      return self.fetchSelectableCheckboxes(this).prop('checked', true).trigger('change');
    });
  }

  renderSelectized() {
    // selectized selects
    if (this.selectizePresent && this.foundationPresent) {
      $('form select.selectize--with-caption').selectize({
        dataAttr: 'data-extra',
        maxOptions: 99999,
        valueField: 'id',
        render: {
          option(data, escape) {
            const optionJSON = JSON.parse(data.text);
            return "<div class=\"option\"><span class=\"option__name\">" + escape(optionJSON.name) + '</span>' + '<span class="option__caption">' + escape(optionJSON.caption) + '</span>' + '</div>';
          },
          item(data, escape) {
            const itemJSON = JSON.parse(data.text);
            return '<div class="item">' + escape(itemJSON.name) + '</div>';
          }
        },
        onInitialize() {
          if (this.$input[0].dataset['allowemptyoption']) {
            this.addOption({value: "", text: this.$input[0].dataset['emptyoptionlabel']});
            this.refreshOptions(false);
          }
          const event = new Event('initialize', { bubbles: true });
          return this.$input[0].dispatchEvent(event);
        }
      });

      $('form select').not(`[data-remote-select]`).not('.selectize--with-caption').not('.picker__select--year').not('.picker__select--month').not('.public-calendar-filter').selectize({
        dataAttr: 'data-extra',
        maxOptions: 99999,

        onChange() {
          // allowing bubbling of events from Selectize fields so we can capture them with Stimulus
          const event = new Event('change', { bubbles: true });
          return this.$input[0].dispatchEvent(event);
        },

        onInitialize() {
          if (this.$input[0].dataset['allowemptyoption']) {
            this.addOption({value: "", text: this.$input[0].dataset['emptyoptionlabel']});
            this.refreshOptions(false);
          }
          const event = new Event('initialize', { bubbles: true });
          return this.$input[0].dispatchEvent(event);
        }
      });

      if (Foundation.MediaQuery.is('small only')) {
        $(this.selectors.noKeyboard).each(function() {
          return $(this).siblings('.selectize-control')
            .find('.selectize-input input')
            .attr('readonly','readonly');
        });
      }

      // This is to solve the problem of class links that are underneath an open
      // select dropdown being clicked when a select option is clicked. When the
      // select dropdown is opened, we disable all the calendar class links and
      // when the select dropdown is closed we re-enable them.
      return $('.public-calendar-filter').selectize({
        onDropdownOpen() {
          return $('.box').each(function() {
            return $(this).addClass('prevent-clicking');
          });
        },

        onDropdownClose() {
          return $('.box').each(function() {
            return $(this).removeClass('prevent-clicking');
          });
        }
      });
    }
  }

  renderSubmitForm() {
    const self = this;
    // submit form from page header submit button
    $(this.selectors.submitForm).on('click', () => $(self.selectors.hasHeaderSubmit).submit());

    // empty hidden optional fields
    return $('form').on('submit', function() {
      return $(this).find(self.selectors.optionsFieldsInput).each(function() {
        const $el = $(this);
        if (!$el.hasClass('selectized')) {
          if (!$el.is(':visible')) {
            return $el.val('');
          }
        } else {
          if (!$el.siblings('.selectize-control').is(':visible')) {
            return $el.val('');
          }
        }
      });
    });
  }

  renderToggleOptionalFields() {
    const self = this;
    // toggling optional fields visibility
    $(this.selectors.toggleOptionalFields).unbind('change');
    return $(this.selectors.toggleOptionalFields).on('change', function() {
      const $el = $(this);
      const $optionalFields = self.fetchOptionalFields($el);

      if (self.hasExpectedValues($el)) {
        // triggered by a <select> or radio buttons
        if (self.hasExpectedValue($el)) {
          return self.show($optionalFields);
        } else {
          return self.hide($optionalFields);
        }
      } else {
        // triggered by a checkbox
        return self.toggle($optionalFields);
      }
    });
  }

  renderToggleStateHidden() {
    // showing optional fields when required
    return $(this.selectors.toggleStateHidden).each(function() {
      return $(this).hide();
    });
  }

  renderToggleStateShown() {
    // showing optional fields when required
    return $(this.selectors.toggleStateShown).each(function() {
      return $(this).show();
    });
  }

  show($el) {
    return $el.slideDown('slow');
  }

  toggle($el) {
    return $el.slideToggle('slow');
  }

  toggleLabelsClassForCheckboxes($el) {
    return $el.closest('.field').find('.label-text').toggleClass('not-selected', !$el.is(':checked'));
  }
};

$(document).ready(function() {
  if (!($('form').length > 0)) { return; }
  window.punchpassForm = new App.Form();
  window.punchpassForm.render();

  return $(document).on('open.zf.reveal', () => window.punchpassForm.render());
});
